import { COOKIES, getCookieValue } from '@/utils/cookies';

type QueryItems = Record<string, string | number | boolean>;

const QUERY_PARAMS = {
    USERNAME: 'username',
    DEVICE_ID: 'deviceId'
};

const queryValueRegex = /%[A-Z_]+%/;

export const generateQuery = async (items: QueryItems, username?: string | null): Promise<string> => {
    if (!Array.isArray(items)) {
        return '';
    }

    const queryParts: string[] = [];

    for (const { query, query_value } of items) {
        if (!queryValueRegex.test(query_value)) {
            queryParts.push(`${query}=${encodeURIComponent(query_value)}`);
            continue;
        }

        if (query === QUERY_PARAMS.USERNAME) {
            if (username) {
                const encoded = btoa(username);
                queryParts.push(`${QUERY_PARAMS.USERNAME}=${encoded}`);
            }
        }

        if (query === QUERY_PARAMS.DEVICE_ID) {
            const ampDeviceId = await getCookieValue(COOKIES.AMP_DEVICE_ID);
            if (ampDeviceId) {
                queryParts.push(`${QUERY_PARAMS.DEVICE_ID}=${encodeURIComponent(ampDeviceId)}`);
            }
        }
    }

    return queryParts.length ? `?${queryParts.join('&')}` : '';
};
